import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/Bullet/ai-dslr.jpg";
import image from "../../assets/product-list-assets/cameras/bullet/ai-dslr.jpg";
import type { Product } from "../../types";
import { bullet } from "../product-groups/cameraSecurity/Bullet";
import { bullet as bulletProductListGroup } from "../product-list-groups/bullet";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const aiDslr: Product = {
  id: "aiDSLR",
  productTitle: "AI DSLR",
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-dslr`],
  storePathParts: {
    productSlug: "uvc-ai-dslr",
    category: "cameras-bullet",
  },
  sku: "UVC-AI-DSLR",
  description: "aiDSLR.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productGroup: bullet,
  productListGroup: bulletProductListGroup,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Without mount:\nØ80 x 89 mm (Ø3.1 x 3.5")\nWith mount:\nØ80 x 153 mm (Ø3.1 x 6")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '4/3" 10MP CMOS' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiDSLR.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "aiDslr.outdoorReady",
      },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
